<template>
    <div v-if="show" style="height: 100%">
        <el-dialog :visible.sync="show" :title="name" width="90%" class="look-url" top="3vh">
            <iframe :src="url" height="100%" width="100%" style="border: medium none"/>
        </el-dialog>
    </div>
</template>

<script>

export default {
    data() {
        return {
            show: false,
            name: '',
            url: ''
        }
    },
    methods: {
        display(data) {
            this.name = data.name
            this.show = true
            this.url = data.url
        }
    }
}
</script>
<style>
.look-url {
    height: 100% !important;
}
.look-url .el-dialog {
    height: 90%;
}
.look-url .el-dialog__body {
    height: calc(100% - 100px);
}
</style>